module.exports = __webpack_public_path__ + "static/CharacterBio2PageHero40@2x.ef5b7308.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/the-realist/CharacterBio2PageHero40@2x.jpg
// module id = 98
// module chunks = 168707334958949